import AuthenticationBackground from "@/components/Authentication/AuthenticationBackground";
import RegisterForm from "@/components/Authentication/RegisterForm";
import Content from "@/components/Content";
import { WithUserLayout } from "@/components/UserLayout";
import { Page } from "@/types/Page";

const RegisterPage: Page = () => {

    return (
        <AuthenticationBackground>
            <Content>
               <RegisterForm />
            </Content>
        </AuthenticationBackground>
    );
}

RegisterPage.layout = WithUserLayout;
export default RegisterPage;